// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rlYJ","textarea":"styles_textarea__OsVnK"};